import React from 'react';
import { Button, ButtonProps } from 'react-bootstrap';
import { ButtonVariantType, ButtonDisplayType } from '../../types';
import './styles.scss';

export interface ButtonType extends ButtonProps {
  id?: string;
  vType?: ButtonVariantType;
  faIcon?:
    | 'fa-instagram'
    | 'fa-facebook'
    | 'fa-pinterest'
    | 'fa-twitter'
    | 'fa-youtube';
  displayType?: ButtonDisplayType;
  onClick?: () => void;
  baseColor?: string;
  hoverColor?: string;
  labelColor?: string;
  labelHoverColor?: string;
}

const WofButton: React.FC<ButtonType> = ({
  children,
  faIcon,
  id,
  baseColor,
  hoverColor,
  labelColor,
  labelHoverColor,
  vType = 'primary',
  displayType = 'button',
  ...remaining
}) => {
  return (
   <React.Fragment>
      {hoverColor ? <style dangerouslySetInnerHTML={{__html: `.wof-button:hover { background-color: `+hoverColor+` !important; border-color: `+hoverColor+` !important; color:`+labelHoverColor+` !important} ` }} /> : null}
    <Button
      {...remaining}
      id={id}
      variant="primary"
      style={(baseColor) ? {backgroundColor:baseColor,borderColor:baseColor,color:labelColor}:{}}
      className={`wof-button wof-button-primary${
        displayType === 'link' ? ' as-link' : ''
      }`}>
      {children}
      {faIcon && (
        <span className="button-icon">
          <i className={`fa ${faIcon}`} aria-hidden="true"/>
        </span>
      )}
    </Button>
   </React.Fragment>
  );
};



export default WofButton;
